import React from 'react';
import PropTypes from 'prop-types';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import style from './style.css';

const Fortress = window.cccisd.fortress;

export default class MainLayout extends React.Component {
    static propTypes = {
        children: PropTypes.node,
        className: PropTypes.string,
        showSecondaryNav: PropTypes.bool,
    };

    static defaultProps = {
        className: 'container',
        showSecondaryNav: false,
    };

    render() {
        const actingRole = Fortress.user.acting.role.handle;

        return (
            <div className={style.wrapper}>
                <div className={style.header}>
                    <Header className={this.props.className} />
                </div>

                <div className={style.body}>
                    <div className={this.props.className}>{this.props.children}</div>
                </div>

                <div className={style.footer}>
                    {actingRole !== 'learner' && <Footer className={this.props.className} />}
                </div>
            </div>
        );
    }
}
